import React from 'react';
import { useTypedSelector } from '@hooks/useTypedSelector';
import Avatar from '@atoms/Avatar';
import './UserPanel.scss';
import { MdAccountCircle, MdEdit } from 'react-icons/md';

interface IUserPanelProps {
    onOrgChange: () => void;
}

const UserPanel: React.FC<IUserPanelProps> = (props: IUserPanelProps) => {
    const user = useTypedSelector((state) => state.auth.user);
    const userAvatar = useTypedSelector((state) => state.userAvatar);

    return (
        <div className="user-info">
            <div className="user-info-main">
                <div className="user-photo" data-testid="user-photo">
                    {userAvatar.photoContent ? (
                        <Avatar
                            photo={`data:image/png;base64,${userAvatar.photoContent}`}
                            firstName={user.firstName}
                            lastName={user.lastName}
                            size="xl"
                        />
                    ) : (
                        <Avatar icon={() => <MdAccountCircle size="66" />} />
                    )}
                </div>

                <div className="user-full-name" data-testid="user-full-name">
                    {`${user.firstName}` + (user.middleName ? ` ${user.middleName}` : '') + ` ${user.lastName}`}
                </div>
            </div>

            <div className="user-info-container">
                <ul className="dottet-ul">
                    <li className="user-info-item">
                        {user.canUserDepartmentView && user.departmentId && (
                            <>
                                <div className="user-department">
                                    <div
                                        className="user-dep-name"
                                        title={user.department}
                                        data-testid="user-department-name"
                                    >
                                        {user.department}
                                    </div>
                                    {user.canUserDepartmentEdit && (
                                        <div className="user-dep-edit" title="Сменить организацию">
                                            <MdEdit
                                                className="edit-dep-btn"
                                                onClick={async () => {
                                                    props.onOrgChange();
                                                }}
                                                data-testid="edit-user-department-button"
                                            />
                                        </div>
                                    )}
                                </div>
                                {user.subdivisionInn && (
                                    <div
                                        className="user-dep-inn"
                                        title={user.subdivisionInn}
                                        data-testid="user-department-inn"
                                    >
                                        ИНН организации: {user.subdivisionInn}
                                    </div>
                                )}
                            </>
                        )}
                    </li>
                    {user.phone && (
                        <li className="user-info-item" data-testid="user-phone">
                            {user.phone}
                        </li>
                    )}
                    {user.email && (
                        <li className="user-info-item" data-testid="user-email">
                            {user.email}
                        </li>
                    )}
                    {user.subdivision && (
                        <li className="user-info-item" data-testid="user-subdivision">
                            {user.subdivision}
                        </li>
                    )}
                    {user.position && (
                        <li className="user-info-item" data-testid="user-position">
                            {user.position}
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
};

export default UserPanel;
